import { Space, Typography } from 'antd';
import React, { type ReactNode } from 'react';
import { DetailSurface } from './detail-surface';

const { Text } = Typography;

export type DetailSectionPanelProps = {
  title: string;
  hint?: string;
  extra?: ReactNode;
  children: ReactNode;
  className?: string;
  flat?: boolean;
};

export function DetailSectionPanel({
  title,
  hint,
  extra,
  children,
  className,
  flat,
}: DetailSectionPanelProps) {
  return (
    <DetailSurface
      flat={flat}
      title={title}
      extra={
        hint || extra ? (
          <Space size={8}>
            {hint ? <Text type="secondary">{hint}</Text> : null}
            {extra}
          </Space>
        ) : null
      }
      className={className}
    >
      {children}
    </DetailSurface>
  );
}
